import {
  AccessTokenCallback,
  SigninRedirectArgs,
  SignoutRedirectArgs,
  UserManager,
  UserManagerSettings,
} from 'oidc-client-ts';

export interface OidcClientServiceCallbacks {
  accessTokenExopiring: AccessTokenCallback;
}

export class OidcClientService {
  private userManager: UserManager;
  constructor(settings: UserManagerSettings) {
    this.userManager = new UserManager(settings);
  }

  public login(args?: SigninRedirectArgs) {
    return this.userManager.signinRedirect(args);
  }

  public signInCallback() {
    return this.userManager.signinCallback();
  }

  public renewToken() {
    return this.userManager.signinSilentCallback();
  }

  public signinSilent() {
    return this.userManager.signinSilent();
  }

  public logout(args?: SignoutRedirectArgs) {
    return this.userManager.signoutRedirect(args);
  }

  public getUser() {
    return this.userManager.getUser();
  }

  /** Drops the stored user and stops its expiry timers, without redirecting to the IdP. */
  public removeUser() {
    return this.userManager.removeUser();
  }

  public setAccessTokenExpiringCallback(cb: AccessTokenCallback) {
    this.userManager.events.addAccessTokenExpiring(cb);
  }

  public setAccessTokenExpiredCallback(cb: AccessTokenCallback) {
    this.userManager.events.addAccessTokenExpired(cb);
  }
}
